export default __webpack_public_path__ + "static/media/14.cc61492c.jpg";